<template>
<div style="padding: 1vw">
    <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
        <div class="pageTitle">
            <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
            공지사항 작성
            </h3>
        </div>
        <div style="display: flex; align-items: center;"/>
    </div>

    <div class="py-4 container-fluid card" style="width: 98%; margin: 1vw">
        <div class="kdh_table_div table-responsive p-0">
            <div class="noticeWriteWrap">
                <div class="inputWrap">
                    <span class="title"> 제목 </span>
                    <input type="text" v-model="title">
                </div>
                <div class="inputWrap">
                    <span class="title"> 작성자 </span>
                    <span> {{writer}} </span>
                </div>
                <div class="inputWrap">
                    <span class="title">노출 대상</span>
                    <div class="radioObj" v-for="(item, i) in targetsList" :key="i">
                        <input 
                        type="checkbox" 
                        :value="item.code"
                        :id="item.code+'M'"
                        v-model="selectedTarget"
                        /> 
                        <label :for="item.code+'M'">{{ item.name }}</label>
                    </div>
                </div>
                <div class="inputWrap">
                    <span class="title">진료 과목</span>
                    <div class="radioObj" v-for="(item, i) in deptList" :key="i">
                        <input 
                            type="checkbox" 
                            :value="item.code"
                            :id="item.code"
                            v-model="selectedMedicalDept"
                        /> 
                        <label :for="item.code">{{ item.name }}</label>
                    </div>
                </div>
                <div class="inputWrap">
                    <span class="title">팝업 공지</span>
                    <div class="radioObj" >
                        <input 
                        type="checkbox" 
                        id="isPopupNotice"
                        v-model="isPopupNotice"
                        /> 
                        <label for="isPopupNotice">팝업 공지사항 등록</label>
                    </div>
                </div>
                <!-- <textarea v-model="content"/> -->
                <Editor
                    :api-key="tinyMceApiKey"
                    :init="initData"
                    initial-value=""
                    v-model="content"
                />
                <div class="inputWrap" style="margin-top: 30px;">
                    <span class="title"> 첨부파일 </span>
                    <button class="btn btn-primary" @click="openFileInput()">파일 첨부</button>
                    <input type="file" multiple @change="handleFileChange" id="fileInput" ref="fileInput">
                </div>
                <div class="fileWrap" style="margin-top: 30px;">
                    <div class="fileRow" v-for="(file, index) in attachments" :key="index">
                        <span class="title hoverPointer" @click="downloadFile(file)">{{ file.name }}</span>
                        <span class="removeFile hoverPointer" @click="removeFile(index)">제거</span>
                    </div>
                </div>
                <div class="buttonWrap">
                    <button class="btn btn-primary" @click="uploadNotice()">작성</button>
                    <router-link
                        :to="`/certilife/notice/list`"
                    >
                    <button class="btn btn-primary">목록</button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>
import Editor from '@tinymce/tinymce-vue'
import { openDialog } from "../utils/utils";
import { MedicalDept } from '@/utils/enums'
export default {
    name: "noticeWrite",
    components: {
        Editor,
    },
    computed: {
        tinyMceApiKey() {
            return process.env.VUE_APP_TINYMCE_ID
        },
    },
    data() {
        return {
            title: "", // 제목
            content: "", // 본문
            targetsList: [], // 노출 대상
            selectedTarget: [], // 선택된 노출 대상
            writer: "", // 작성자
            attachments: [], // 첨부파일
            deptList: [],
            selectedMedicalDept: [],
            isPopupNotice: false,

            // 기존 CDN TinyMCE API key
            // ys3n9gcl5jl8s8xfx7x3dmzk5n70i2pspkvblzunxv9vhjqo


            
            initData: {
                selector: "textarea",
                menubar: false,
                plugins: [  
                    "lists",
                    "link",
                    "image",
                    "charmap",
                    "preview",
                    "searchreplace",
                    "fullscreen",
                    "media",
                    "table",
                    "code",
                    "help",
                    "emoticons",
                    "codesample",
                    "quickbars",
                ],
                toolbar: "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
                tinycomments_mode: "embedded",
                tinycomments_author: "Author name",
                setup: (editor) => {
                    editor.on("input", () => {
                        this.content = editor.getContent();
                    })
                },
                images_upload_url: process.env.VUE_APP_SERVERURL,
                images_upload_handler: (blobInfo) => 
                    new Promise((resolve, reject) => {
                    const formData = new FormData();
                    formData.append("file", blobInfo.blob());
                    this.$apiInstance
                        .post(`/object-storages`, formData)
                    .then(res => {
                    resolve(res.data.url);
                    })
                    .catch(error => {
                        console.log(error);
                        reject(error);
                    });
                }),
            },
        };
    },

    async mounted() {
        // this.initTinyMCE();
        this.writer = localStorage.getItem("userNameCerti");
        await this.getDeptList();
        await this.getTargets();
    },
    methods: {
        // 주요 API

        // 과 목록 가져오기
        async getDeptList() {
            try {
                const response = await this.$apiInstance.get(`/items/medical/depts`);
                if(response.status === 200 || response.status === 201) {
                    this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
                }
            } catch(error) {
                console.log(error);
            }
        },

        // 노출 대상 가져오기
        async getTargets() {
        try {
            const response = await this.$apiInstance.get(`/notices/targets/list`);
            if(response.status === 200 || response.status === 201) {
            this.targetsList = response.data;
            } 
        } catch (error) {
            console.log(error);
        }
        },

        // 공지사항 등록
        async uploadNotice() {
        if(!await this.validateData()) return;
        const obj = {};
        obj.title = this.title;
        obj.targets = JSON.parse(JSON.stringify(this.selectedTarget));
        obj.contents = tinymce.activeEditor.getContent();
        obj.medicalDept = this.selectedMedicalDept;
        obj.isPopupNotice = this.isPopupNotice;

        obj.fileUrls = [];
        if(this.attachments.length > 0) {
            for(const item of this.attachments) {
                const fileData = new FormData();
                fileData.append("file", item);
                const fileUrl = await this.uploadImageOnObjectStorage(fileData);
                if(fileUrl) obj.fileUrls.push(fileUrl);
            }
        }

        try {
            const response = await this.$apiInstance.post(`/notices`, obj);
            if(response.status === 200 || response.status === 201) {
                await openDialog("공지사항 등록이 완료되었습니다.","success", "확인")
                .then(() => {
                    this.$router.push({ name: "noticesList" });
                });
                } else {
                    await openDialog("공지사항 등록에 실패하였습니다.", "error", "확인");
                }

        } catch (error) {
            console.log(error);
            await openDialog("공지사항 등록에 실패하였습니다.", "error", "확인");
        }
        },

        // 이미지 오브젝트스토리지에 업로드
        async uploadImageOnObjectStorage(fileData) {
            const response = await this.$apiInstance.post(`/object-storages`, fileData);
            if(response.status === 200 || response.status === 201) {
                return response.data.url;
            } else {
                return "";
            }
        },

        // 파일첨부 창이 잘 안떠서 별도로 만든 클릭 메소드
        openFileInput() {
            this.$refs.fileInput.click();
        },

        // 파일 onchange
        handleFileChange(event){
            const files = event.target.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                this.attachments.push(file); 
            }
        },

        // 파일 다운로드
        downloadFile(file) {
            const downloadLink = document.createElement("a");
            downloadLink.target = "_blank";
            downloadLink.href = URL.createObjectURL(file);
            downloadLink.download = file.name; 
            downloadLink.click();
        },

        // 파일 제거
        removeFile(index) {
            this.attachments.splice(index, 1); 
        },

        // 에디터 로드
        initTinyMCE() {
            tinymce.init({
            selector: "textarea",
            menubar: false,
            plugins: [  
                "lists",
                "link",
                "image",
                "charmap",
                "preview",
                "searchreplace",
                "fullscreen",
                "media",
                "table",
                "code",
                "help",
                "emoticons",
                "codesample",
                "quickbars",
            ],
            toolbar: "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
            tinycomments_mode: "embedded",
            tinycomments_author: "Author name",
            setup: (editor) => {
                editor.on("input", () => {
                    this.content = editor.getContent();
                })
            },
            images_upload_url: process.env.VUE_APP_SERVERURL,
            images_upload_handler: (blobInfo) => 
                new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append("file", blobInfo.blob());
                this.$apiInstance
                    .post(`/object-storages`, formData)
                .then(res => {
                    resolve(res.data.url);
                    })
                    .catch(error => {
                    console.log(error);
                    reject(error);
                    });
                }),
            });
        },

        // 업로드 전 검증
        async validateData() {
            let result = true;
            if (!this.title) {
                await openDialog("제목을 입력해 주세요.", "error", "확인");
                result = false;
            } 
            // else if(this.selectedTarget.length === 0) {
            //     await openDialog("노출 대상을 최소 하나 이상 선택해 주세요.", "error", "확인");
            //     result = false;
            // } 
            else if(!this.content) {
                await openDialog("내용을 입력해 주세요.", "error", "확인");
                result = false;
            } 
            // else if(this.selectedMedicalDept.length === 0) {
            //     await openDialog("진료 과목을 최소 하나 이상 선택해 주세요.", "error", "확인");
            //     result = false;
            // } 
            return result;
        },
    },
};
</script>
